import convert from '@/sui/data/sheets/convert'

export default {
  save: function (sheet, surveillance) {
    const req = convert.clientToServer(sheet)

    if (req.sheet.t === 'spy4') {
      if (req.sheet.f.uf == null || req.sheet.f.uf.length < 3 ||
          req.sheet.f.unitType == null || req.sheet.f.cvps == null) {
        return {
          error: `
<div>
  Trois champs sont obligatoires afin de pouvoir créer une fiche SPY4 :
  <ul>
    <li>le code du service,</li>
    <li>un nom d'uf d'au moins 3 caractères,</li>
    <li>et l'inclusion ou non des CVPs dans l'enquête.</li>
  </ul>
</div>`
        }
      }
    } else if (req.sheet.t !== 'bactADI' &&
        req.sheet.t !== 'observa4' &&
        req.sheet.t !== 'denominators' &&
        req.sheet.t !== 'toolsUsage' &&
        req.sheet.t !== 'badiCause' &&
        (req.sheet.f.uf == null || req.sheet.f.uf === '' ||
         req.sheet.f.unitType == null || req.sheet.f.unitType === '')) {
      return {
        error: `Champs requis : l'identifiant et le code du service sont obligatoires et
doivent être renseignés.`
      }
    }

    if (req.errors.length > 0) {
      return {
        error: req.errors.join('\n')
      }
    }

    req.sheet.s = surveillance.id
    req.sheet.y = surveillance.year

    const newSheet = (req.sheet.id == null || req.sheet.id === '')

    let prefix = 'sheet'
    if (req.sheet.t === 'denominators') {
      prefix = 'denominators'
    }
    if (req.sheet.t === 'toolsUsage') {
      prefix = 'toolsUsage'
    }

    const event = newSheet ? `${prefix}/add` : `${prefix}/update`
    return {
      newSheet: newSheet,
      event: event,
      req: req.sheet
    }
  }
}
